/**
 * Created by Cemali Gencer on 11.10.2016.
 */
function openModalOrderStatusCheck(){

    if(parseInt(window.userId) === 0 ){
        if(Vivense.loginPopup){
            $('#registrationForm .inner-center-mod .login-text').show();
            $("#registrationForm .inner-center-mod .short-desc").hide();
            Vivense.loginPopup.open("siparisim_nerede", "" );
            return;
        }
        window.location.href = '/vivense-uye-girisi.html';
        return;
    }
    else{
        window.location.href = '/siparislerim.html?ref=siparisim_nerede';
        return;
    }
}


function  openModalLoginForm() {
    $(".login-form-slide-box").addClass("slide-register");
    Vivense.loginPopup.open('footer');
}